export default "__VITE_ASSET__N8THQCiGQAK_wQXofhkUjg__ 480w, __VITE_ASSET__XivDCLKvo3rsiwL$eU0pkA__ 745w";